module.exports = __webpack_public_path__ + "img/10.55c5621a.jpg";